export enum ApplicationStatus {
  CREATED = 'CREATED',
  IN_PROGRESS = 'IN_PROGRESS',
  SUBMITTED = 'SUBMITTED',
  INTERVIEW_PENDING = 'INTERVIEW_PENDING',
  INTERVIEW = 'INTERVIEW',
  APPROVE_PENDING = 'APPROVE_PENDING',
  APPROVED = 'APPROVED',
  HIRED = 'HIRED',
  CLOSED_REJECTED = 'CLOSED_REJECTED',
  CLOSED_REVOKED = 'CLOSED_REVOKED',
}

export enum ApplicationGroup {
  UNREVIEWED = 'UNREVIEWED',
  INTERVIEW = 'INTERVIEW',
  INTERNSHIP = 'INTERNSHIP',
  REJECTED = 'REJECTED',
}

export enum ApplicationRating {
  FIRE = 'FIRE',
  GOOD = 'GOOD',
  THINK = 'THINK',
  DISLIKE = 'DISLIKE',
}
